// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { SEARCH_ACTIVITY_TYPES_ORDER_BY_KEY } from "."
import {
  SearchActivityTypesRequest,
} from "generated/legebill/site/activitytype/v4/activity_type_pb"

export type StorageWriter = (value: SearchActivityTypesRequest.OrderBy) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(SEARCH_ACTIVITY_TYPES_ORDER_BY_KEY, value.toString())
}

export const persistOrderBy = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setSearchOrderBy.match),
      mergeMap(action => of(action.payload).pipe(
        tap(persist),
        map(_ => Actions.orderByPersisted()),
        catchError(_ => of(Actions.orderByPersistFailed())),
      )),
    )

export default persistOrderBy(persist)

